import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { getItem } from '../utils/localStore';
class fileUploadForPlannerApi {
    static fileUpload(file) {
        const TOKEN = getItem('auth_token');
        const data = new FormData();
        data.append('file', file);
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Authorization': TOKEN,
                mimeType: 'multipart/form-data',
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: data
            }
            return fetch(BASE_URL + `/planner/identity_file/upload`, body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default fileUploadForPlannerApi;